<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idDiagnostico" class="form-label">IdDiagnostico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoDiagnostico.idDiagnostico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idClasDiag" name="idClasDiag" v-model="datoDiagnostico.idClasDiag"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idClasDiag" class="form-label"> Clas Diag</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="clasDiag" name="clasDiag" v-model="datoDiagnostico.clasDiag" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalClasDiagLOV"
                      title="Buscar Clasificación de Diagnósticos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoDiagnostico.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoDiagnostico.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarDiagnostico" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarDiagnostico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditDiagnostico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPlanDiag</th>
          <th scope="col">IdDiagnostico</th>
          <th scope="col">IdInterconsulta</th>
          <th scope="col">Tipo</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">DiagnosticoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plandiag in datosPaginados" :key="plandiag.idPlanDiag">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(plandiag.idPlanDiag)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(plandiag.idPlanDiag)" title="Editar">edit_square</i></td>
          <td>{{plandiag.idPlanDiag}}</td>
          <td>{{plandiag.idDiagnostico}}</td>
          <td>{{plandiag.idInterconsulta}}</td>
          <td>{{plandiag.tipo}}</td>
          <td>{{plandiag.observacion}}</td>
          <td>{{plandiag.estado}}</td>
          <td>{{plandiag.diagnosticoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteDiagnostico(plandiag.idPlanDiag)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPlanDiag" class="form-label">IdPlanDiag</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlanDiag" name="idPlanDiag" v-model="datoPlanDiag.idPlanDiag" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idDiagnostico" class="form-label">IdDiagnostico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoPlanDiag.idDiagnostico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoPlanDiag.idInterconsulta"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label"> Interconsulta</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="interconsulta" name="interconsulta" v-model="datoPlanDiag.interconsulta" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalInterconsultaLOV"
                      title="Buscar Atención: Interconsulta">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoPlanDiag.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoPlanDiag.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlanDiag" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlanDiag" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: ClasDiag -->
    <ClasDiagLOV @DatosClasDiag="GetDataClasDiagLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: PlanDiag -->
    <PlanDiagLOVdet @DatosPlanDiag="GetDataPlanDiagLOVdet($event)"/>
<!-- Lista de Valores: Interconsulta -->
    <InterconsultaLOVdet @DatosInterconsulta="GetDataInterconsultaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
import ClasDiagLOV from '../../components/lovs/ClasDiagLOV.vue'
// Listas de valores master
// Listas de valores details
import PlanDiagLOVdet from '../../components/lovs/PlanDiagLOV.vue'
import InterconsultaLOVdet from '../../components/lovs/InterconsultaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, ClasDiagLOV
// Listas de valores master
// Listas de valores details
, PlanDiagLOVdet
, InterconsultaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      diagnosticos : [],
      datoDiagnostico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idDiagnostico: '',
// Variables master
// Variables details
      plandiags : [],
      datoPlanDiag : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idDiagnostico = this.$route.params.p_iddiagnostico
    this.abrirEditar(this.p_idDiagnostico)
    this.getPlanDiags()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoDiagnostico.idDiagnostico === ''){
        swal("Error!", "El elemento idDiagnostico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.idClasDiag === ''){
        swal("Error!", "El elemento idClasDiag no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarDiagnostico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/diagnosticos', this.datoDiagnostico)
          swal("Correcto!", "Diagnostico creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDiagnostico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/diagnosticos', this.datoDiagnostico)
          swal("Correcto!", "Diagnostico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoDiagnostico={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idDiagnostico){
      this.modalWindow = true
      if(idDiagnostico != null){    
           api.get('/vwdiagnosticos/'+idDiagnostico).then(resp=>{
          this.datoDiagnostico = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarDiagnostico(){
      this.$router.push('/Diagnostico')
    },
// Procedimientos master
// Procedimientos detalle
    async getPlanDiags() {
      const resp = await api.get('/plandiags')
      this.plandiags = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.plandiags.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwplandiags/nombre/'+this.nombreBusqueda).then(response=>{
          this.plandiags=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.plandiags.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwplandiags').then(response=>{
      this.plandiags=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.plandiags.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoPlanDiag.idDiagnostico === ''){
        swal("Error!", "El elemento idDiagnostico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.idClasDiag === ''){
        swal("Error!", "El elemento idClasDiag no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPlanDiag(){
      if(this.validarForm() === 1){
        try {
          this.datoPlanDiag.idDiagnostico = this.datoDiagnostico.idDiagnostico;
          await api.post('/plandiags', this.datoPlanDiag)
          this.getPlanDiags();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlanDiag creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlanDiag(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plandiags', this.datoPlanDiag)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlanDiag creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlanDiag={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPlanDiag){
      this.modalWindow = true
      if(idPlanDiag != null){    
           api.get('/vwplandiags/'+idPlanDiag).then(resp=>{
          this.datoPlanDiag = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPlanDiag){
      this.modalWindow = true
      if(idPlanDiag != null){
        this.$router.push('/plandiagmd/'+idPlanDiag)
      }
    },
    async deletePlanDiag (idPlanDiag) {
      try{
        await api.delete('/plandiags/'+idPlanDiag)
          this.getPlanDiags()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataClasDiagLOV(data) {
      this.datoDiagnostico.idClasDiag = data.idClasDiag;
      this.datoDiagnostico.clasDiag = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataPlanDiagLOVdet(data) {
      this.datoPlanDiag.idPlanDiag = data.idPlanDiag;
      this.datoPlanDiag.planDiag = data.nombre;
    },
//    Lista de Valores
    GetDataInterconsultaLOVdet(data) {
      this.datoPlanDiag.idInterconsulta = data.idInterconsulta;
      this.datoPlanDiag.interconsulta = data.nombre;
    },
// Listas de valores details
  },
}
</script>
